const apiHandler = {
    baseUrl: () => process.env.API_HANDLER_BACKEND_URL,
    basePath: "api/opta/futbol",
    apiKey: "ole", // es "ole" a propósito, no un copy/paste. Se preserva tal cual para no cambiar qué torneos se ven.
    timeoutMs: 10000,
};

/**
 * Rutas de api handler, no feeds de Opta: los nombres son los que expone el gateway
 * (`tournament`, `fixture`, `match-stats`), no los de Opta (`tournamentcalendar`, `match`, `matchstats`).
 */
export const apiHandlerEndpoint = {
    competitionTournaments: (competitionId) => `tournament/${competitionId}`,
    teamTournaments: (teamId) => `team/${teamId}/tournaments`,
    team: (teamId) => `team/${teamId}`,
    fixture: (calendarId) => `fixture/${calendarId}`,
    matchStats: (matchId) => `match-stats/${matchId}`,
    commentary: (matchId) => `commentary/${matchId}`,
};

const jsonHeaders = {
    Accept: "application/json",
    "Accept-encoding": "gzip",
};

// Los params vacíos no se mandan: api handler los interpreta como filtro inválido
const withValues = (params) =>
    Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
    );

/**
 * Pide un endpoint de api handler y devuelve el `data` o `null` ante cualquier error.
 * Devolver `null` en vez del error permite que quien llama use `?.` y `??`
 * en lugar de revisar el `errorCode` en cada respuesta.
 */
export const requestOpta = async (path, params = {}) => {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), apiHandler.timeoutMs);

    const query = new URLSearchParams({ ...withValues(params), apikey: apiHandler.apiKey });
    const url = `${apiHandler.baseUrl()}/${apiHandler.basePath}/${path}?${query}`;

    try {
        const response = await fetch(url, { headers: jsonHeaders, signal: controller.signal });
        const { code, data, error } = await response.json();

        if (error || code !== 200) {
            console.error(`[opta] ${path}: code ${code}`, error ?? "");
            return null;
        }

        return data ?? null;
    } catch (error) {
        const reason = error?.name === "AbortError" ? `timeout de ${apiHandler.timeoutMs}ms` : error?.message;
        console.error(`[opta] ${path}:`, reason ?? error);
        return null;
    } finally {
        clearTimeout(timeoutId);
    }
};
